import { render, staticRenderFns } from "./mdArticle.vue?vue&type=template&id=87b9024a&scoped=true"
import script from "./mdArticle.vue?vue&type=script&lang=js"
export * from "./mdArticle.vue?vue&type=script&lang=js"
import style0 from "./mdArticle.vue?vue&type=style&index=0&id=87b9024a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b9024a",
  null
  
)

export default component.exports